import { Link } from 'react-router-dom';
import { useApiQuery } from '../api/hooks';
import { Icon } from '../design/icons';
import { BUILD, shortSha } from '../../lib/build';

// "Web ≠ API": this tab's bundle was built from a different commit than the API it is talking to
// (GET /health `revision`). Both must be known — local dev ('unknown') never warns. Shown in every
// skin's top bar; it links to About, which explains the three-way comparison in full.

export interface HealthInfo { revision?: string | null; version?: string | null; deployed_at?: string | null }

const known = (s: string | null | undefined): s is string => Boolean(s) && s !== 'unknown';

/** True when both the web build and the API revision are known and differ. */
export function versionSkew(webSha: string | null | undefined, apiRevision: string | null | undefined): boolean {
  return known(webSha) && known(apiRevision) && webSha !== apiRevision;
}

export function VersionSkewChip({ webSha = BUILD.sha }: { webSha?: string }) {
  const health = useApiQuery<HealthInfo>(['health'], '/health', { staleTime: 5 * 60_000 });
  const api = health.data?.revision ?? null;
  if (!versionSkew(webSha, api)) return null;
  return (
    <Link to="/about" className="hf-skew-chip" role="status" title={`This tab runs web ${shortSha(webSha)}; the API runs ${shortSha(api)}. Reload, or see About.`}>
      <Icon name="alert-triangle" size={12} /> Web ≠ API
    </Link>
  );
}
